import { jsx } from "react/jsx-runtime";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { validateTidalLicense } from "../../base/index.js";
function CloudDownload(props) {
  return /* @__PURE__ */ jsx(
    CloudDownloadIcon,
    {
      "data-testid": "CloudDownload",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CloudDownload",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
CloudDownload.tidalIconMeta = {
  categories: "fileActions",
  name: "CloudDownload"
};
validateTidalLicense();
export {
  CloudDownload
};
//# sourceMappingURL=CloudDownload.js.map
